import { Text } from '@/components';
import { Tooltip as AntTooltip, type TooltipProps } from 'antd';
import type { FC } from 'react';

const DEFAULT_MAX_WIDTH = '320px';

export const Tooltip: FC<TooltipProps> = ({ children, title, ...props }) => {
  const overlayStyle = {
    ...props.overlayStyle,
    maxWidth: props.overlayStyle?.maxWidth || DEFAULT_MAX_WIDTH,
  };

  return (
    <AntTooltip
      title={typeof title === 'string' ? <Text text={title} /> : title}
      overlayStyle={overlayStyle}
      data-dd-privacy="allow"
      {...props}
    >
      {children}
    </AntTooltip>
  );
};
